















import {Component, Vue} from 'vue-property-decorator';
import NavBar from '@/components/NavBar.vue'
import SideMenu from '@/components/SideMenu.vue'
import Modal from '@/components/Modal.vue'
import Navigation from "@/components/Navigation.vue";
import ModalAuthorization from "@/components/ModalAuthorization.vue";
import SmallModalMessage from "@/components/SmallModalMessage.vue";
import {progressPoints} from "@/store/types";
import pages from '@/router/pages'
import {MutationList as navMutations} from "@/store/modules/navigation/mutation-list";
import {MutationList as ConfigMutations} from "@/store/modules/config/mutation-list";
import {MutationList as modalMutations} from "@/store/modules/modal/mutation-list";
import ModalServicesList from "@/components/ModalServicesList.vue";
import axios from 'axios';

@Component({
    components: {
        NavBar, SideMenu, Modal, Navigation, ModalAuthorization, ModalServicesList, SmallModalMessage
    }
})
export default class App extends Vue {

    private rootNamespace = 'root/';
    private navigationNamespace = 'navigation/';
    private configNamespace = 'config/';
    private modalNamespace = 'modal/';

    // get sidebarVisibility(): boolean {
    //     return this.$store.getters[`${this.rootNamespace}isSidebarVisible`]
    // }

    get transitionName() {
        return this.$store.getters[`${this.rootNamespace}getTransition`];
    }


    /**
     *  created hook to preload all necessary information
     *  it loads navigation point and content
     *  introduction point content
     * */
    created() {
        if (!this.$store.getters[`${this.navigationNamespace}getInitial`]) {
            this.$store.commit(`${this.modalNamespace}${modalMutations.SELECT_LOADING_MODAL}`, 'Loading navigation configuration');

            // Loading routing points

            const arr: progressPoints[] = [];
            pages.forEach((item: any, index: number) => {
                arr.push({
                    rightArrow: true,
                    leftArrow: true,
                    name: item.meta.name,
                    index: index,
                    description: item.meta.description,
                    prevRoute: index === 0 ? '/' : pages[index - 1].path,
                    nextRoute: index === pages.length - 1 ? '/search' : pages[index + 1].path
                } as progressPoints);
            });
            arr[arr.length - 1].rightArrow = true;
            arr[0].leftArrow = true;
            this.$store.commit(`${this.navigationNamespace}${navMutations.SET_NAVIGATION_POINTS}`, arr);

            // Loading navigation content - message and names got all navigation tiles on all pages

            this.$store.commit(`${this.modalNamespace}${modalMutations.SET_MODAL_MESSAGE}`, 'Loading navigation content');


             axios.get('https://dev.palmamedical.lv/api/rest/config/navigation')
                 .then(response => {
                     this.$store.commit(`${this.configNamespace}${ConfigMutations.SET_INITIAL_NAVIGATION_VALUES}`, response.data);
                 })
                 .catch(e => {
                     this.$store.commit(`${this.modalNamespace}${modalMutations.SELECT_MESSAGING_MODAL}`, {
                         header: 'an error happened while loading app',
                         message: e
                     });
                 });


            // axios.get('https://dev.palmamedical.lv/api/rest/config/introduction')
            // .then(response => {
            //     this.$store.commit(`${this.configNamespace}${ConfigMutations.SET_INITIAL_INTRODUCTION_CONTENT}`, response.data);
            // })
            //     .catch(e => {
            //         this.$store.commit(`${this.modalNamespace}${modalMutations.SELECT_MESSAGING_MODAL}`, {
            //             header: 'an error happened while loading app',
            //             message: e
            //         });
            //     });

            this.$store.commit(`${this.navigationNamespace}${navMutations.SET_INITIALIZATION_TO_TRUE}`);
            this.$store.commit(`${this.modalNamespace}${modalMutations.SET_MODAL_VISIBILITY_FALSE}`);
        }
    }
}
